export const SET_SERVICE_OPTIONS_REQUEST = "SET_SERVICE_OPTIONS_REQUEST";
export const SET_SERVICE_OPTIONS_ERROR = "SET_SERVICE_OPTIONS_ERROR";
export const SET_SERVICE_OPTIONS_SUCCESS = "SET_SERVICE_OPTIONS_SUCCESS";


export const SET_SERVICE_OPTIONS_PAGE = "SET_SERVICE_OPTIONS_PAGE";

